import { useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { Table, Button } from 'reactstrap';
import type { Warehouse } from '../../api/platformTenants';
import { useTenantWarehouses } from '../../api/platformTenants';
import { WarehouseDrawer } from '../../components/tenants/WarehouseDrawer';

interface Props { tenantId: number; disabled: boolean; }

type DrawerMode = 'closed' | 'create' | { kind: 'edit'; wh: Warehouse };

export default function TenantDetailWarehouses({ tenantId, disabled }: Props) {
  const auth = useAuth();
  const token = auth.user?.access_token ?? null;

  const { data, isLoading } = useTenantWarehouses(tenantId, token);
  const [drawerMode, setDrawerMode] = useState<DrawerMode>('closed');

  return (
    <div>
      <div className="d-flex justify-content-end mb-2">
        <Button
          type="button"
          color="primary"
          size="sm"
          onClick={() => setDrawerMode('create')}
          disabled={disabled}
          title={disabled ? 'Riattiva il tenant per modificare warehouses' : undefined}
        >+ Nuovo warehouse</Button>
      </div>
      {isLoading ? <p>Caricamento…</p> : (
        <div className="table-responsive">
        <Table className="table-sm align-middle table-striped mb-0" style={{ width: '100%' }}>
          <thead><tr><th>Code</th><th>Name</th><th>Timezone</th><th /></tr></thead>
          <tbody>
            {data?.data.map((wh) => (
              <tr key={wh.id}>
                <td style={{ fontFamily: 'var(--vp-font-mono)' }}>{wh.code}</td>
                <td>{wh.name}</td>
                <td>{wh.timezone}</td>
                <td>
                  <Button type="button" color="light" size="sm"
                          disabled={disabled}
                          onClick={() => setDrawerMode({ kind: 'edit', wh })}>→ Apri</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        </div>
      )}

      {drawerMode === 'create' && (
        <WarehouseDrawer mode="create" tenantId={tenantId} isOpen onClose={() => setDrawerMode('closed')} />
      )}
      {typeof drawerMode === 'object' && drawerMode.kind === 'edit' && (
        <WarehouseDrawer mode="edit" tenantId={tenantId} isOpen
                         initial={{ ...drawerMode.wh, address: drawerMode.wh.address ?? null }}
                         onClose={() => setDrawerMode('closed')} />
      )}
    </div>
  );
}
